import { createFileRoute } from '@tanstack/react-router';

import ProductReviewsPage from '@/components/products/specific/ProductReviewsPage';

export const Route = createFileRoute('/products/$id/reviews')({
	component: ProductReviewsPage,
});
